<template>
  <div id="app">
    <MapView
      ref="map_view"
      :cardinal_directions="cardinal_directions"
      :ciudades="ciudades"
      :locationes="getLocations"
      :grupos="getGroups"
      :transitos="transit"
      :types="types"
    />
    <SideMenu
      ref="side_menu"
      :lista_espacios="getListSpacesBillboards"
      :duration="getDurationSpaces"
      :start_date="getStartDateSpaces"
      :cardinal_directions="cardinal_directions"
      @removeFromList="removeFromList"
    />
    <div id="bigbutton">
      <!--       <a href="#loginModal"  v-show="!isEmptyThiList && !getToken"  data-bs-toggle="modal" data-bs-target="#loginModal"  class="material-btn bt_cotizar"  role="button"> Cotizar Selección <i class="fas fa-check"></i> </a> -->
      <a
        href="#"
        v-show="!isEmptyThiList"
        class="material-btn bt_cotizar"
        @click="validateSideMenu()"
        role="button"
      >
        {{ $t("boton.cotizar") }}
        <i class="fas fa-check"></i>
      </a>
    </div>

    <!-- Modales -->
    <ConfirmBorrar
      ref="confirm_borrar"
      :locations="getLocations"
      :data_valla="data_billboard"
    ></ConfirmBorrar>
    <ConfirmCotizacion ref="confirm_cotizacion"></ConfirmCotizacion>
    <ConfirmRegistro ref="confirm_registro"></ConfirmRegistro>
    <CotizacionFormModal
      ref="cotizacion_form"
      :lista_espacios="getListSpacesBillboards"
      :locations_="getLocations"
      :grupos="getGroups"
      :cant_espacios="cant_selects"
      :validateRecaptcha="validateRecaptcha"
      :resetTheRecaptcha="resetRecaptcha"
    ></CotizacionFormModal>
    <LoginFormModal
      ref="login_form"
      :cant_selects="cant_selects"
      :temp_valla="Temp_Valla"
      :validateRecaptcha="validateRecaptcha"
      :resetTheRecaptcha="resetRecaptcha"
    ></LoginFormModal>
    <ForgotPasswordFormModal
      ref="forgot_password_form"
      :validateRecaptcha="validateRecaptcha"
      :resetTheRecaptcha="resetRecaptcha">

    </ForgotPasswordFormModal>
    <ResetPasswordModal
      ref="reset_password_form"
      :validateRecaptcha="validateRecaptcha"
      :resetTheRecaptcha="resetRecaptcha">

    </ResetPasswordModal>
    <RegistroFormModal
      ref="registro_form"
      :validateRecaptcha="validateRecaptcha"
      :resetTheRecaptcha="resetRecaptcha"
    ></RegistroFormModal>
    <DetallesValla
      ref="detalles_valla_modal"
      :lista_espacios="getListSpacesBillboards"
      :cardinal_directions="cardinal_directions"
      :ciudades="ciudades"
      :types="types"
    ></DetallesValla>
    <DetallesTransit
      ref="detalles_transit_modal"
      :cardinal_directions="cardinal_directions"
      :ciudades="ciudades"
      :types="types"
    ></DetallesTransit>
    <GruposEspacios
      ref="grupos_valla_modal"
      :locations_="getLocations"
      :grupos="getGroups"
      :cardinal_directions="cardinal_directions"
    ></GruposEspacios>
    <LandscapeModal ref="landscape_modal"></LandscapeModal>
    <!-- Modales -->
    <div class="cont-captcha">
      <!-- <vue-recaptcha
        ref="invisibleRecaptcha"
        :sitekey="sit_ky"
        :loadRecaptchaScript="true"
        recaptchaScriptId="invisibleRecaptcha1"
        size="invisible"
        @verify="onCaptchaVerified"
        @expired="onExpired"
      ></vue-recaptcha> -->
    </div>
  </div>
</template>

<script>
import Snackbar from "node-snackbar";
import { mapActions, mapGetters } from "vuex";
import MapView from "./components/MapView.vue";
import SideMenu from "./components/SideMenu.vue";

/* Modales */
import ConfirmBorrar from "./components/Modales/ConfirmBorrar";
import ConfirmCotizacion from "./components/Modales/ConfirmCotizacion";
import ConfirmRegistro from "./components/Modales/ConfirmRegistro";
import CotizacionFormModal from "./components/Modales/CotizacionFormModal";
import LoginFormModal from "./components/Modales/LoginFormModal";
import RegistroFormModal from "./components/Modales/RegistroFormModal";
import ForgotPasswordFormModal from "./components/Modales/ForgotPasswordFormModal.vue";
import ResetPasswordModal from "./components/Modales/ResetPasswordModal.vue";
import DetallesValla from "./components/Modales/DetallesValla";
import DetallesTransit from "./components/Modales/DetallesTransit";
import GruposEspacios from "./components/Modales/GruposEspacios";
import LandscapeModal from "./components/Modales/LandscapeModal";

import * as requestCiudades from "./request/ciudades.js";
import * as vallas_request from "./request/vallas.js";
import * as transit_request from "./request/transit.js";
import * as usage_request from "./request/usage.js";
//mixins
import VallasMixin from "./mixins/vallas";
import _ from "lodash";
// import $ from "jquery";

window._ = require("lodash");

export default {
  name: "app",
  components: {
    MapView,
    // VueRecaptcha,
    SideMenu,
    ConfirmBorrar,
    ConfirmCotizacion,
    ConfirmRegistro,
    LoginFormModal,
    CotizacionFormModal,
    RegistroFormModal,
    ForgotPasswordFormModal,
    ResetPasswordModal,
    DetallesValla,
    DetallesTransit,
    GruposEspacios,
    LandscapeModal,
  },
  mixins: [VallasMixin],
  created() {
    this.changeLang();
    this.getCardinalDirs();
    this.getCiudades();
    this.getTransits();
    this.getGrupos();
    this.getTypes();
  },
  mounted() {
    this.$root.$on("EventAddToList", (data) => {
      this.addToList(data);
    });
    this.$root.$on("EventRemoveList", (data) => {
      this.removeFromList(data);
    });
    var vm = this;
    // eslint-disable-next-line
    $("#lang-select-change").change(function (event) {
      vm.changeLang(event.target.value);
    });
    // eslint-disable-next-line
    $(document).ready(function () {
      // Disable right-click on full page
      $("body").on("contextmenu", function (e) {
        return false;
      });

      // Disable cut, copy ,paste
      $("body").bind("cut copy paste", function (e) {
        e.preventDefault();
      });
    });
  },
  updated() {
    this.isEmptyList();
    this.getCantEspacios()
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getLang",
      "getToken",
      "getLocations",
      "getGroups",
      "getBillboards",
      "getListSpacesBillboards",
      "getDurationSpaces",
      "getStartDateSpaces"
    ]),
  },
  data() {
    return {
      lista_espacios: [],
      isEmptyThiList: true,
      data_billboard: null,
      cardinal_directions: [],
      //        locations:[],
      //        grupos:[],
      ciudades: [],
      types: [],
      transit: [],
      modal_instance: null,
      cant_selects: 0,
      Temp_Valla: null,
      recaptchaKey: "",
      sit_ky: process.env.VUE_APP_RECAPTH_KEY_PROD,
    };
  },
  methods: {
    ...mapActions([
      "change_locations",
      "change_groups",
      "change_bilboards",
      "change_list_spaces",
      "changue_lang"
    ]),

    getCantEspacios() {
      let count = 0;
      this.getListSpacesBillboards.map((item) => {
        count = count + item.vallas.length
      });

      this.cant_selects = count
    },

    async validateRecaptcha(key) {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      this.$recaptcha(key).then((token) => {
        this.recaptchaKey = key;
        this.onCaptchaVerified(token);
      });

      // Do stuff with the received token.
    },
    onCaptchaVerified(token) {
      switch (this.recaptchaKey) {
        case "register":
          this.$refs.registro_form.onCaptchaVerified(token);
          break;
        case "forgotPassword":
          this.$refs.forgot_password_form.onCaptchaVerified(token);
          break;
        case "resetPassword":
          this.$refs.reset_password_form.onCaptchaVerified(token);
          break;
        case "Quote":
          this.$refs.cotizacion_form.onCaptchaVerified(token);
          break;

        default:
          this.$refs.login_form.onCaptchaVerified(token);
          break;
      }
    },
    resetRecaptcha() {
      this.recaptchaKey = "";
    },
    onExpired() {},
    async getTransits() {
      let vm = this;
      await transit_request.getAll().then((response) => {
        vm.transit = response.data.data;
      });
    },
    async getCiudades() {
      let vm = this;
      await requestCiudades.getAll().then((resonse) => {
        vm.ciudades = resonse.data.data;
        _.forEach(resonse.data.data, function (element) {
          vm.lista_espacios.push({
            id: element.id,
            country_code: element.country_code,
            titulo: element.name,
            vallas: [],
          });
        });
        if (vm.getListSpacesBillboards.length == 0) {
          vm.change_list_spaces(vm.lista_espacios);
        }
      });
      vm.$refs.map_view.changeCenter();
    },
    // obtiene las vallas y crea los makers
    async getVallas() {
      var vm = this;
      await vallas_request
        .getAll()
        .then(function (response) {
          vm.change_locations(response.data.data);
        })
        .catch(function (err_) {
          console.log(err_);
        });
      // Luego de cargar el Api de google carga los datos de la DB
      vm.$refs.map_view.$gmapApiPromiseLazy({ load: true }).then(() => {
        vm.$refs.map_view.createMarkers();
      });
    },
    // Obtiene los grupos de vallas
    async getGrupos() {
      var vm = this;
      await vallas_request
        .groups()
        .then(function (response) {
          vm.change_groups(response.data.data);
        })
        .catch(function (err_) {
          console.log(err_);
        });
      vm.getVallas();
    },
    // Obtiene los tipos de vallas
    async getTypes() {
      let vm = this;
      await vallas_request.types().then((response) => {
        vm.types = response.data.data;
      });
    },

    getInfo() {},
    addToList(data) {
      let limit_ = 30;
      let count = 0,
        sub_count = 0;
      this.getListSpacesBillboards.map((item) => {
        sub_count = sub_count + item.vallas.length;
      });

      let isToAdd = true;
      if (sub_count < 1) {
        isToAdd = true;
      } else {
        if (this.getToken == null) {
          isToAdd = false;
        }
      }
      if (isToAdd) {
        // Usage Unit and Dialy: selected
        usage_request.post({
          id_billboard: data.id,
          selected: 1,
        });
        // Si hay espacios existentes
        if (this.getListSpacesBillboards.length > 0) {
          let lista_espacios_ = this.getListSpacesBillboards;

          _.forEach(lista_espacios_, function (element) {
            if (parseInt(element.id) == parseInt(data.location_id)) {
              if (!_.find(element.vallas, { id: data.id })) {
                element.vallas.push({
                  id: data.id,
                  direccion: data.address,
                  subtitle: data.subtitle,
                  part_circuit: data.part_circuit && data.part_circuit === 'yes',
                  de_cara_al: data.facing_id,
                  id_valla: data.id,
                  type_id: data.type_id,
                });
              } // if
            } // if
            count = count + element.vallas.length;
          });
          this.change_list_spaces(lista_espacios_);
        } else {
          // si no existia ningun expacio
          this.lista_espacios[0].vallas.push({
            id: data.id,
            direccion: data.address,
            subtitle: data.subtitle,
            part_circuit: data.part_circuit && data.part_circuit === 'yes',
            de_cara_al: data.facing_id,
            id_valla: data.id,
            type_id: data.type_id,
          });
          this.change_list_spaces(this.lista_espacios);
        }
        this.isEmptyThiList = false;
        Snackbar.show({
          text: this.$t("alert.agregado"),
          actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
          backgroundColor: "#1D0E54",
          actionTextColor: "#ee5b66",
        });
      }
      this.cant_selects = count; // guarda la cantidad de selecionados
      if (!isToAdd) {
        $("[data-lity-close]", window.parent.document).trigger("click");
        $("#loginModal").modal("show");
        Snackbar.show({
          text: this.$t("alert.debes_logearte"),
          pos: "bottom-center",
          backgroundColor: "#ff1744",
          actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
          actionTextColor: "#fff",
        });
        this.Temp_Valla = data;
      }
    },
    removeFromList(data) {
      let lista_espacios_ = this.getListSpacesBillboards;
      lista_espacios_.map((element) => {
        if (+element.id == +data.location_id) {
          if (element.vallas.find((item) => item.id == +data.id)) {
            element.vallas = element.vallas.filter(
              (valla) => +valla.id != +data.id
            );
          }
        }
      });

      this.change_list_spaces(lista_espacios_);
      this.$refs.side_menu.$forceUpdate();
      this.cant_selects = this.cant_selects - 1;
      Snackbar.show({
        text: this.$t("alert.removido"),
        actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
        backgroundColor: "#1D0E54",
        actionTextColor: "#ee5b66",
      });
    },
    isEmptyList() {
      let count = 0;
      this.getListSpacesBillboards.map((item) => {
        item.vallas.length > 0 ? count++ : null;
      });
      if (count == 0) {
        this.isEmptyThiList = true;
      } else {
        this.isEmptyThiList = false;
      }
    },
    resetList() {
      this.lista_espacios = [];
      this.change_list_spaces([]);
      this.getCiudades();
    },
    setInfo(data) {
      this.data_billboard = data;
    },
    validateSideMenu() {
      if (!this.$refs.side_menu.returnData()) {
        Snackbar.show({
          text: this.$t("alert.falta_fecha"),
          pos: "bottom-center",
          backgroundColor: "#ff1744",
          actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
          actionTextColor: "#fff",
        });
      } else {
        if (this.getToken && this.getUser) {
          $("#cotizModal").modal("show");
        } else {
          Snackbar.show({
            text: this.$t("alert.debes_logearte"),
            pos: "bottom-center",
            backgroundColor: "#ff1744",
            actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
            actionTextColor: "#fff",
          });
          $("#loginModal").modal("show");
        }
      }
    },
    resetTemp() {
      this.Temp_Valla = null;
    },
    changeLang(langP = undefined) {
      let params = this.getParams(window.location.href);
      let langStorag = localStorage.getItem("lang_vallas_do");
      let lang = "es";
      if (params.hasOwnProperty("lang")) {
        lang = params.lang;
      } else {
        if (langStorag) {
          lang = langStorag;
        }
      }
      if (langP) {
        lang = langP;
      }
      document.querySelectorAll("#lang-select-change select")[0].value = lang;
      this.$parent.$i18n.locale = lang;
      this.$parent.$validator.localize(lang);
      localStorage.setItem("lang_vallas_do", lang);
    },
    getParams(url) {
      var params = {};
      var parser = document.createElement("a");
      parser.href = url;
      var query = parser.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
      return params;
    },
  },
};
</script>

<style>
.top-lang {
  float: right;
  font-size: 0.8em;
  padding-left: 12px;
  color: #8cdbff;
  letter-spacing: 0.07em;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 100%;
}
.top-lang .lang-select select {
  width: 100%;
  font-size: 0.9em;
  background-color: transparent;
  color: #ffffff !important;
  height: 32px;
  padding: 0 10px;
  border: 1px #27b8b3 solid;
  border-radius: 0;
}
</style>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/alertas.json" />
